<template>
  <div class="classification">
    <div class="header">
      <el-form
        ref="formTool"
        :model="formTool"
        :inline="true"
        @submit.native.prevent
        style="text-align: left"
      >
        <el-form-item label="">
          <el-input
            style="width: 150px"
            v-model="formTool.memberName"
            placeholder="搜索业务员名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item label="">
          <el-input
            style="width: 150px"
            v-model="formTool.memberAccount"
            placeholder="搜索业务员账号"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item label="">
          <el-input
            style="width: 150px"
            v-model="formTool.contractName"
            placeholder="搜索合同名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item label="">
          <el-input
            style="width: 150px"
            v-model="formTool.coopShopName"
            placeholder="搜索CSO公司"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item label="">
          <el-input
            style="width: 150px"
            v-model="formTool.targetName"
            placeholder="搜索指标名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item label="">
          <el-input
            style="width: 150px"
            v-model="formTool.taskName"
            placeholder="搜索任务名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item prop="status" label="">
          <el-select
            v-model="formTool.status"
            placeholder="筛选状态"
            size="small"
            style="width: 150px"
            clearable
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in statusArr"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getList(1)"
            >查询</el-button
          >
          <el-button size="small" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="center" style="position: relative">
      <MyTable
        :index="false"
        :table-data="tableData"
        :page="page"
        :table-option.sync="tableOption"
        @page-change="tablePageChange"
      >
        <template slot="status" slot-scope="scope">
          {{ statusMap[scope.row.status] }}
        </template>
        <template slot="tools" slot-scope="scope">
          <div class="table-op-col">
            <el-link
              type="primary"
              :underline="false"
              size="small"
              @click="openDetail(scope.row)"
              >完税凭证列表</el-link
            >
          </div>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable/index.vue";
import { csoDutyPaidProofMedicalParentPage } from "@/api/complianceCso/salesman";
export default {
  components: {
    MyTable,
  },
  data() {
    return {
      formTool: {
        memberName: "",
        memberAccount: "",
        contractName: "",
        medicalShopName: "",
        targetName: "",
        taskName: "",
        status: "",
      },
      statusMap: {
        1: "进行中",
        2: "已完结",
      },
      tableData: [],
      tableOption: [
        { label: "业务员名称", prop: "memberName" },
        { label: "业务员账号", prop: "memberAccount" },
        { label: "合同名称", prop: "contractName" },
        { label: "CSO公司", prop: "coopShopName" },
        { label: "指标名称", prop: "targetName" },
        { label: "任务名称", prop: "targetTaskName" },
        { label: "任务审核通过时间", prop: "auditTime" },
        { label: "已完成任务金额", prop: "amount" },
        { label: "已审核凭证金额", prop: "taskAmount" },
        { label: "状态", prop: "status", slot: true },
        { label: "操作", prop: "tools", slot: true, width: "180px" },
      ],
      page: { total: 0, current: 1, size: 10 },
    };
  },
  computed: {
    statusArr() {
      // 获取 statusMap 的 key 数组
      const kesyArr = Object.keys(this.statusMap);
      const valuesArr = Object.values(this.statusMap);
      const arr = [];
      for (let i = 0; i < kesyArr.length; i++) {
        arr.push({ label: valuesArr[i], value: kesyArr[i] });
      }
      return arr;
    },
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    openDetail(row) {
      this.$router.push({
        path: "/compliance/compliance-taxPaymentReceipt-receiptList",
        query: { memberId: row.memberId, targetTaskId: row.targetTaskId },
      });
    },
    getList(num) {
      if (num) {
        this.page.current = num;
      }
      const { current, size } = this.page;
      let params = { current, size, ...this.formTool };
      this.listLoading = true;
      csoDutyPaidProofMedicalParentPage(params)
        .then((res) => {
          this.tableData = res.records;
          this.page.total = res.total;
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleRefresh() {
      this.getList();
    },
    tablePageChange() {
      this.getList();
    },
    handleReset() {
      for (let key in this.formTool) {
        this.formTool[key] = "";
      }
      this.getList(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.classification {
  padding: 0px;
  background: white;

  .header {
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f5f5f5;
    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);
  }

  .table-op-col {
    display: flex;
    align-items: center;

    .el-link {
      & + .el-link {
        margin-left: 8px;
      }
    }
  }
}
</style>
